/**
 * This component wraps React-Router's Redirect by providing name-based routing.
 * (Helps to narrow down the scope of possible format changes to routes.)
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router';
import routeConfiguration from '../../routeConfiguration';
import { pathByRouteName } from '../../util/routes';

const NamedRedirect = ({
  name,
  search = '',
  state = {},
  params = {},
  push = false,
  locale: propsLocale,
}) => {
  const intl = useIntl();

  const pathname = pathByRouteName(name, routeConfiguration(), params, propsLocale || intl.locale);
  return <Navigate replace={!push} state={state} to={{ pathname, search }} />;
};

export default NamedRedirect;
